import React from 'react';
import { Tooltip, Typography } from 'antd';
import dayjs from 'dayjs';

const UNITS = [
  ['year', 365 * 24 * 60 * 60],
  ['month', 30 * 24 * 60 * 60],
  ['day', 24 * 60 * 60],
  ['hr', 60 * 60],
  ['min', 60],
];

// "just now", "20 mins ago", "1 day ago", "3 months ago"
export const timeAgo = (value) => {
  if (!value) return null;
  const seconds = Math.max(0, dayjs().diff(dayjs(value), 'second'));
  if (seconds < 60) return 'just now';
  for (const [unit, size] of UNITS) {
    const count = Math.floor(seconds / size);
    if (count >= 1) return `${count} ${unit}${count > 1 ? 's' : ''} ago`;
  }
  return 'just now';
};

// Sorter for Antd columns: most recent last, rows without activity first.
export const sortByLastActivity = (a, b) =>
  (a?.last_activity ? dayjs(a.last_activity).valueOf() : 0) -
  (b?.last_activity ? dayjs(b.last_activity).valueOf() : 0);

const LastActivityCell = ({ value }) => {
  if (!value) return <Typography.Text type="secondary">-</Typography.Text>;
  return (
    <Tooltip title={dayjs(value).format('DD MMM YYYY, hh:mm A')}>
      <span>{timeAgo(value)}</span>
    </Tooltip>
  );
};

export default LastActivityCell;
